/* globals jQuery */
import 'fitvids.1.1.0'

import responsiveNav from './responsive-nav.js'
import accordion from './jquery.accordion.js'
import './gsap-anchor-nav.js';

(($) => {

    $.fn.accordion = accordion

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    // Make nav menu nice & responsive
    const mainNav = document.querySelector('nav.main-nav');
    if( mainNav ){
        responsiveNav(mainNav,{
            navType: 'dropdown'
        });
    }

    const jumpNav = document.querySelector('.jump-links-nav');
    if(jumpNav){
        responsiveNav(jumpNav,{
            wrapperSelector: '.jump-links-wrapper',
            navType: 'dropdown',
            menuButtonSelector: '.jump-links-toggle'
        });
    }

    // Responsive Videos
    $('.rtecontent, .video').fitVids();

    // Link to and open accordion
    const openAccordionFromHash = () => {
        const target = document.getElementById(window.location.hash.slice(1));
        if (target instanceof HTMLDetailsElement && target.matches('.accordion details')) {
            target.open = true;
        }
    };
    window.addEventListener('hashchange', openAccordionFromHash);
    openAccordionFromHash();

    // Filter on change
    $('.js-goOnChange').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

    // Search dialog controls are centralized here instead of inline onclick handlers.
    const searchDialog = document.getElementById('searchDialog');
    const btnOpenSearch = document.getElementById('btnOpenSearch');
    const btnCloseSearch = document.getElementById('btnCloseSearch');

    if (searchDialog && btnOpenSearch && btnCloseSearch) {
        btnOpenSearch.addEventListener('click', function() {
            searchDialog.showModal();
        });

        btnCloseSearch.addEventListener('click', function() {
            searchDialog.close();
            btnOpenSearch.focus();
        });

        searchDialog.addEventListener('close', function() {
            // Escape/backdrop-close should also restore focus to the opener.
            btnOpenSearch.focus();
        });
    }

    // Pause/play video on .js-pause-video button click
    $('.js-pause-video').on('click', function() {
        const video = $(this).siblings('video')[0];
        if (video) {
            if (video.paused) {
                video.play();
                $(this).attr('aria-pressed', 'true');
                $(this).attr('aria-label', 'Pause video');
            } else {
                video.pause();
                $(this).attr('aria-pressed', 'false');
                $(this).attr('aria-label', 'Unpause video');
            }
            $(this).toggleClass('is-paused');
        }
    });

})(jQuery)
